module.exports = __webpack_public_path__ + "static/media/burger-1.2167293b.jpg";